// sample for key country
export const TIME_FORMAT = {
  BASE: 'hh:mm a, dd-MMM-yy',
  EN: 'hh:mm a, d-MMM-yy',
  ID: 'HH:mm a, d-MMM-yy',
  TH: 'HH:mm a, d-MMM-yy',
  VN: 'HH:mm a, d-MM-yy',
  BT: 'HH:mm',
  FM: 'hh:mm a, dd-MMM-yy',
  TF: 'HH:ss a, dd-MMM-yy', // 24 Hours
  FY: 'hh:mm a, dd-MMM-yyyy', // full year
  TB: 'HH:mm a,',
  DT: 'dd-MMM-yyyy'
};

export const DATE_FORMAT = {
  BASE: 'MM/DD/YY',
  SHORT: 'MMM DD, YYYY'
};
